import { EProvider } from 'Common/consts';
import { getTableColumns } from './getTableColumns';
import { TABLE_COLUMNS_DESCRIPTIONS } from './descriptionUKB';
/**
 * Get table columns
 *
 * @param props - an object with the following fields:
 * - providerId - Id of provider
 * - referrerData - Referrer data for the variant link
 * - columnsData - Additional data for the variant link
 * @returns formatted table columns
 */
export const getColumns = ({ providerId, referrerData, columnsData, }) => {
    const columnsMapper = {
        [EProvider.FinnGen]: getTableColumns({}, referrerData, columnsData),
        [EProvider.UKB]: getTableColumns(TABLE_COLUMNS_DESCRIPTIONS, referrerData, columnsData),
    };
    return columnsMapper[providerId];
};
